import { render } from "./ReplaceImageLabel.vue?vue&type=template&id=677892b4&scoped=true"
import script from "./ReplaceImageLabel.vue?vue&type=script&lang=js"
export * from "./ReplaceImageLabel.vue?vue&type=script&lang=js"

import "./ReplaceImageLabel.vue?vue&type=style&index=0&id=677892b4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-677892b4"]])

export default __exports__